import type { FC } from "react"

import { COST_BREAKDOWN_DECIMAL_PRECISION } from "../constants"
import { formatCostBreakdownCurrency } from "../utils/formatCostBreakdownCurrency"

import { LabelValue } from "./LabelValue"

import type { GrLineTariff } from "@/graphql/codegen/graphql"
import { roundToPrecision } from "@/utils/number"

interface TariffsLabelValuesProps {
  tariffs: GrLineTariff[] | null | undefined
  totalBareCost: number
}

export const TariffsLabelValues: FC<TariffsLabelValuesProps> = ({ tariffs, totalBareCost }) => {
  if (tariffs?.length) {
    return (
      <>
        {tariffs.map((tariff, index) => {
          const percentage = roundToPrecision((tariff.amount / totalBareCost) * 100, COST_BREAKDOWN_DECIMAL_PRECISION)
          const amount = formatCostBreakdownCurrency(tariff.amount)
          return <LabelValue key={index} label='Tariffs' value={`${amount} (${percentage}%)`} />
        })}
      </>
    )
  }
  return <LabelValue label='Tariffs' value='-' />
}
